<template>

    <div class="surface-section px-4 py-3 md:px-6 lg:px-8 text-center">

        <!-- Top line -->
        <div class="font-medium text-900">
            &copy; 2026 Simply Investing.
            <a href="#" @click.prevent="processDisclaimer"
               class="text-primary hover:underline" role="button">Disclaimer</a>.
            <a href="#" @click.prevent="processTerms"
               class="text-primary hover:underline" role="button">Terms of Use</a>.
            <a href="#" @click.prevent="processPrivacy"
               class="text-primary hover:underline" role="button">Privacy Policy</a>.
        </div>

        <!-- Small space + Powered By -->
        <div class="font-medium text-900 mt-4">
            Powered By
        </div>

        <!-- Logo with tiny top margin -->
        <div class="mt-1">
            <img src="images/blocks/logos/kitrin-logo-black-revised-rev1.png"
                 alt="Kitrin Logo"
                 height="40">
        </div>

    </div>


</template>

<script>
export default {
    methods: {
        processDisclaimer() {
            console.log("[SiFooter][processTerms] Beginning.");
            window.open("https://www.simplyinvesting.com/disclaimer", '_blank');
        },
        processTerms() {
            console.log("[SiFooter][processTerms] Beginning.");
            window.open("https://www.simplyinvesting.com/terms", '_blank');
        },
        processPrivacy() {
            console.log("[SiFooter][processPrivacy] Beginning.");
            window.open("https://www.simplyinvesting.com/privacy", '_blank');
        },

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
